"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pincara": {
    "091900d3": [{
      "hkey": "17b6fb66",
      "slug": "pincara",
      "name": "Pincara",
      "primary": true,
      "skipSearch": false
    }],
    "gambaro": [{
      "hkey": "17b6fb66",
      "slug": "pincara",
      "name": "Pincara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4064a022": [{
      "hkey": "17b6fb66",
      "slug": "pincara",
      "name": "Pincara",
      "primary": true,
      "skipSearch": false
    }],
    "paolino": [{
      "hkey": "17b6fb66",
      "slug": "pincara",
      "name": "Pincara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;